import type { CopyPayload } from './clipboardPayload';

/**
 * Write both formats with the async clipboard API (spec §7). Must be called
 * straight from the click: Safari only allows clipboard writes during the
 * user gesture. Resolves false when the browser refuses or lacks the API;
 * the caller then offers the manual-copy dialog (formatting may be lost).
 */
export const writeRichClipboard = async (
  payload: CopyPayload,
): Promise<boolean> => {
  try {
    if (
      typeof navigator === 'undefined' ||
      !navigator.clipboard?.write ||
      typeof ClipboardItem === 'undefined'
    ) {
      return false;
    }
    await navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([payload.html], { type: 'text/html' }),
        'text/plain': new Blob([payload.text], { type: 'text/plain' }),
      }),
    ]);
    return true;
  } catch {
    return false;
  }
};

/** Plain text (a citation, a question). */
export const writePlainClipboard = async (text: string): Promise<boolean> => {
  try {
    if (typeof navigator === 'undefined' || !navigator.clipboard?.writeText) {
      return false;
    }
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
